import { render, staticRenderFns } from "./ContractorDetails.vue?vue&type=template&id=741f89ba&"
import script from "./ContractorDetails.vue?vue&type=script&lang=js&"
export * from "./ContractorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports